module.exports = __webpack_public_path__ + "static/girly-1970089c2d025979fb595d4038c3d8a6.png";